module.exports = __webpack_public_path__ + "img/option2.8685b63d.png";